<section class="alert-settings-container">
  <section class="header">
    <span class="title">Alert Settings</span>
  </section>
  <section class="form-container">
    <form [formGroup]="alertSettingsForm">
      <section class="section">
        <div class="input-field">
          <label>Alert Title</label>
          <mat-form-field class="form-field" appearance="outline">
            <input
              matInput
              formControlName="alertTitle"
              placeholder="Give this alert a name..."
              maxlength="100"
              [matTooltip]="tooltipMessage"
              matTooltipPosition="right"
              matTooltipClass="error-tooltip new-alert-error-tooltip"
              #tooltip="matTooltip"
              matTooltipDisabled="true"
            />
            @if (isError) {
            <mat-icon class="error-icon">error</mat-icon>
            }
          </mat-form-field>
        </div>
        <div class="input-field">
          <label>Subject</label>
          <mat-form-field class="form-field" appearance="outline">
            <input
              matInput
              formControlName="alertSubject"
              placeholder="Give this alert a custom subject line..."
            />
          </mat-form-field>
        </div>
      </section>
      <section class="section">
        <div class="input-field">
          <label class="frequency-label">Frequency</label>
          <app-frequency-selector
            [frequency]="this.frequency"
            [selectedDays]="this.selectedDays"
            [isMonthlyDelivery]="this.isMonthlyDelivery"
            (frequencyChange)="onFrequencyChange($event)"
            (selectedDaysChange)="onSelectedDaysChange($event)"
          ></app-frequency-selector>
        </div>
      </section>
      <section class="section email-fields">
        <div class="email-input-field">
          <app-input-chips
            placeHolder="Enter Cc recipients"
            controlName="ccAlert"
            [label]="'Cc'"
            [color]="'primary'"
            [chips]="ccEmails"
            [separatorKeysCodes]="separatorKeysCodes"
            [forceShowAll]="true"
            [minChipGridHeight]="118"
            (chipsChange)="onChipsChange($event, 'cc')"
          >
          </app-input-chips>
        </div>
        <div class="email-input-field">
          <app-input-chips
            placeHolder="Enter Bcc recipients"
            controlName="bccAlert"
            [label]="'Bcc'"
            [color]="'primary'"
            [chips]="bccEmails"
            [separatorKeysCodes]="separatorKeysCodes"
            [forceShowAll]="true"
            [minChipGridHeight]="118"
            (chipsChange)="onChipsChange($event, 'bcc')"
          >
          </app-input-chips>
        </div>
      </section>
    </form>
  </section>
</section>
